module.exports = __webpack_public_path__ + "static/media/img1.26f8143c.png";